import { Key } from "./Key";

export class BettingOfferKeyDelete extends Key {
}